import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './error-page-not-found.component.html',
    standalone: false
})
export class ErrorPageNotFoundComponent implements OnInit {
  private titleService = inject(Title);
  private translate = inject(TranslateService);

  public ngOnInit(): void {
    this.titleService.setTitle(this.translate.instant('TITLE.PAGE_NOT_FOUND') + ' - myA');
  }

}
